import { render, staticRenderFns } from "./CustomSwitch.vue?vue&type=template&id=2f6a703b&scoped=true&"
import script from "./CustomSwitch.vue?vue&type=script&lang=js&"
export * from "./CustomSwitch.vue?vue&type=script&lang=js&"
import style0 from "./CustomSwitch.vue?vue&type=style&index=0&id=2f6a703b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6a703b",
  null
  
)

export default component.exports